module.exports = __webpack_public_path__ + "img/thumbnail_Dingo_j_normal.b484a6a9.png";